<div [formGroup]="formGroup">
  <div class="row">
    <div class="col-xl-3 col-lg-4 col-md-6">
      <snelstart-ui-select-form-control [options]="(this.balanceProviderService.balanceProviderOptions$ | async) ?? []"
                                        formControlName="balanceProviderId"
                                        id="balanceProviderId"
                                        label="Selecteer extern boekhoudpakket"
      >
      </snelstart-ui-select-form-control>
    </div>
    @if (this.balanceProviderService.identityProvider$ | async; as identityProvider) {
      @if (this.balanceProviderService.identityProviderStatus$ | async; as identityProviderStatus) {
        <div class="col-xl-3 col-lg-4 col-md-6">
          @if (identityProviderStatus.authenticated) {
            <snelstart-ui-button [config]="this.logoffBalanceProviderButtonConfiguration"
                                 id="end-session-button"
                                 class="me-1 mt-1 mt-md-3 mb-2 w-100 d-block mw-256-px"
                                 icon="arrow-right-from-bracket"
                                 type="secondary"
            >
              Uitloggen bij {{ identityProvider.name }}
            </snelstart-ui-button>
          } @else {
            @if (identityProvider.supportsAuthorize) {
              <snelstart-ui-button [config]="this.loginBalanceProviderAuthorizeButtonConfiguration"
                                   id="authorize-button"
                                   class="me-1 mt-1 mt-md-3 mb-2 w-100 d-block mw-256-px"
                                   icon="arrow-up-right-from-square"
                                   type="secondary"
              >
                Inloggen bij {{ identityProvider.name }}
              </snelstart-ui-button>
            } @else if (identityProvider.supportsAccessToken) {
              <snelstart-ui-text-form-control [required]=true
                                              class="me-1 mb-2 w-100 d-block mw-256-px"
                                              formControlName="accessToken"
                                              id="access-token"
                                              label="Sleutel"
              >
              </snelstart-ui-text-form-control>
              <snelstart-ui-button [config]="this.loginBalanceProviderAccessTokenButtonConfiguration"
                                   [disabled]="formGroup.controls.accessToken.invalid"
                                   id="authorize-button"
                                   class="me-1 mt-1 mt-md-3 mb-2 w-100 d-block mw-256-px"
                                   type="secondary"
              >
                Inloggen bij {{ identityProvider.name }}
              </snelstart-ui-button>
            }
          }
        </div>
      }
    }
  </div>
  @if (this.balanceProviderService.identityProviderStatus$ | async; as identityProviderStatus) {
    @if (this.balanceProviderService.selectedBalanceProvider$ | async; as selectedBalanceProvider) {
      @if (identityProviderStatus.authenticated) {
        @if (selectedBalanceProvider.requiresEnvironmentSelection) {
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6">
              <snelstart-ui-select-form-control [options]="(this.balanceProviderService.balanceProviderEnvironmentOptions$ | async) ?? []"
                                                formControlName="environmentId"
                                                id="environmentId"
                                                label="Selecteer een {{ selectedBalanceProvider.name }} omgeving"
              >
              </snelstart-ui-select-form-control>
            </div>
          </div>
        }
        @if (selectedBalanceProvider.requiresAdministrationSelection) {
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6">
              <snelstart-ui-select-form-control [options]="(this.balanceProviderService.balanceProviderAdministrationOptions$ | async) ?? []"
                                                formControlName="administrationId"
                                                id="administrationId"
                                                label="Selecteer een {{ selectedBalanceProvider.name }} administratie"
              >
              </snelstart-ui-select-form-control>
            </div>
            @if (this.balanceProviderService.selectedBalanceProviderAdministration$ | async) {
              <div class="col-xl-3 col-lg-4 col-md-6">
                <snelstart-ui-button (click)="this.selectBalanceProviderAdministration()"
                                     id="authorize-button"
                                     class="me-1 mt-1 mt-md-3 mb-2 w-100 d-block mw-256-px"
                                     type="secondary"
                >
                  Koppelen
                </snelstart-ui-button>
              </div>
            }
          </div>
        }
      }
    }
  }
</div>
